app.controller('CIFFIN-CTRL',
    ['$scope', '$rootScope', 'deviceDetector', '$uibModal', '$http', '$window', '$timeout', '$q', '$filter',
    function ($scope, $rootScope, deviceDetector, $uibModal, $http, $window, $timeout, $q, $filter) {

    $scope.stage = 2;
    $scope.CIFInvestor = {};
    $scope.ktpPhoto = '';
    $scope.device = deviceDetector;
    $scope.append = '';
    $scope.statusCamera = 'true';
    $scope.counter = 10;

    $scope.series5 = [];
    //$scope.series7 = [];

    $scope.capture = function () {
        $scope.counter = 10;
        var mytimeout = $timeout($scope.onTimeout, 1000);
    }

    $scope.onTimeout = function () {
        $scope.counter--;
        if ($scope.counter > 0) {
            mytimeout = $timeout($scope.onTimeout, 1000);
        }
        else {
            console.log('capturing...', $scope.stage);
            $scope.$broadcast('ngWebcam_capture');
            //alert("Time is up!");
        }
    }

    

    $scope.reset = function () {
        $scope.counter = 10;
        mytimeout = $timeout($scope.onTimeout, 1000);
    }



    $scope.camfacing = 'env';
    $scope.ktpPhoto = '';

    $scope.KTPconfig = {
        //viewerWidth: 300,
        //viewerHeight: 300,
        outputWidth: 1080,
        outputHeight: 1280,
        delay: 5,
        shots: 8,
        countdown: 0,
        flashFallbackUrl: 'dist/webcamjs/webcam.swf',
        shutterUrl: 'shutter.mp3',
        flashNotDetectedText: 'Camera not found or use Chrome Browser'
    };

    $scope.KTPonCaptureComplete = function (src) {
        console.log('capturecomplete',$scope.stage);
        $scope.counter = 10;

        //if ($scope.stage == 5) {
        //    console.log("CAPTURE COMPLETE STAGE 5");
        //    $scope.series7 = [];
        //    for (var i = 0; i < src.length; i++) {
        //        $scope.series7.push(src[i]);
        //    }
        //    //$scope.series7 = src;
        //    $scope.submit();

        //}

        if ($scope.stage == 4) {
            console.log("CAPTURE COMPLETE STAGE 4");
            $scope.counter = 10;

            $scope.series5 = [];
            for (var i = 0; i < src.length; i++)
            {
                $scope.series5.push(src[i]);
            }
            $scope.submit();
            //$scope.changeStage(5);
        }

        
        //var el = document.getElementById('result');
        //var img = document.createElement('img');
        //img.src = src[$scope.KTPconfig.shots - 1];
        //img.width = 240;
        //img.height = 180;
        //el.appendChild(img);
    };


    $scope.KTPonLive = function (err) {
        console.log('live');
    };


    $scope.KTPonError = function (err) {
        $scope.statusCamera = '';
        console.log(" stat : ", $scope.statusCamera);
        Swal.fire('Error', 'Mohon maaf anda tidak dapat melanjutkan proses selanjutnya karena perangkat anda tidak terdeteksi kamera', 'error');
    };



    $scope.KTPonLoad = function () {
        // $log.info('ktp.onLoad');
        console.log('load');
    };

    $scope.KTPcapture = function () {
        $scope.$broadcast('ngWebcam_capture');
    };

    $scope.KTPon = function () {
        $scope.$broadcast('ngWebcam_on');
    };

    $scope.KTPoff = function () {
        $scope.$broadcast('ngWebcam_off');
        $scope.captureButtonEnable = false;
    };

    $scope.KTPremove = function () {
        $scope.ktpPhoto = '';
    }










    $scope.openCamera = function () {
        let message = 'KTP';
        let url = 'ModalCamera.html';
        let ctrl = 'CameraController';


        //if ($scope.device.isMobile())
        //{
        //    url = 'ModalBrowse.html';
        //    ctrl = 'BrowseController';
        //    $scope.append = 'data:image/png;base64,';
        //}

        var modalInstance = $uibModal.open({
            animation: true,
            templateUrl: url,
            controller: ctrl,
            size: 'md',
            resolve: {
                items: function () {
                    return message;
                }
            }
        });
        modalInstance.result.then(function (resolvedResponse) {
            //console.log('ktp',resolvedResponse);
            if (resolvedResponse) {
                $scope.ktpPhoto = resolvedResponse;
            }
        }, function () { });
    };

    $scope.KTPremove = function () {
        $scope.ktpPhoto = '';
    };


    var allPromise = $q.all([
         $http({
             method: 'POST',
             url: 'service/client.svc/retrieveSession',
         }).then(function (data) {
             if (!data.data.d) {
                 $http({
                     method: 'GET',
                     url: 'service/client.svc/SignOut',
                 }).then(function (data) {
                     if (data.data.d == true) {
                         $window.location.href = "#/login";
                         $window.location.reload();
                     }
                 }, function (error) { })
             }
             else
                 $scope.currentUser = data.data.d;
         }, function (error) { }),


    ]);




    $scope.changeStage = function (newstage) {
        $scope.stage = newstage;

        if($scope.stage==4)
        {
            $scope.$broadcast('ngWebcam_camUsr');
            $scope.camfacing = 'usr'
            Swal.fire({
                imageUrl: 'dist/images/verification/step1.png',
                imageAlt: 'E-KTP',
                background: '#1c252c',
                width: '600px',
                allowEscapeKey: false,
                allowOutsideClick: false,
                animation: false
            });            
        }

        //if ($scope.stage == 5) {
        //    $scope.$broadcast('ngWebcam_restart');
        //    $scope.$broadcast('ngWebcam_camUsr');
        //    $scope.camfacing = 'usr'
        //    Swal.fire({
        //        imageUrl: 'dist/images/verification/step2.png',
        //        imageAlt: 'E-KTP',
        //        background: '#1c252c',
        //        width: '600px',
        //        allowEscapeKey: false,
        //        allowOutsideClick: false,
        //        animation: false,
        //        onOpen: () => {
        //            Swal.fire.showLoading()
        //            setTimeout(() => { Swal.fire.hideLoading() }, 3000)
        //        },
        //    }).then((result) => {
        //        if (!result.dismiss) {
        //            $scope.counter = 6;
        //            var mytimeout = $timeout($scope.onTimeout, 1000);
        //            //console.log('user read the important message')
        //        }
        //    })

            
        //}
    }


    allPromise.then(function () {

        $http({
            method: 'GET',
            url: 'service/client.svc/getCIF',
        }).then(function (data) {
            if (data.data.d != null) {
                var obj = data.data.d;
                $scope.CIFInvestor = data.data.d;
                $scope.CIFInvestor.Stage = 4;
                
            } // END IF data.data.d
        }, function (error) { });

        console.log("stage", $scope.stage);
    });



    $scope.submit = function () {
        $rootScope.AlertShowLoading('warning', 'Loading...', '', 0);
        $http({
            method: 'POST',
            url: 'service/client.svc/ImageVerification',
            data:
            {
                imageData: {
                    series5: $scope.series5,
                    //series7: $scope.series7,
                }
            }
        }).then(function (data) {
            Swal.fire('success', 'Permohonan pembukaan rekening efek Anda telah kami terima. Silahkan cek email', 'success').then(function () {
                $window.location.href = "#/dashboard";
            });

        }, function (error) {
            Swal.fire('Error', 'error - Please check your connection' + error, 'error');
        });
    }

    $scope.logOff = function () {
        $http({
            method: 'POST',
            url: 'service/client.svc/logOff',
        }).then(function (data) {
            console.log(data);
            if (data.data.d == true) {
                $window.location.href = "#/login";
                $window.location.reload();
            }
        }, function (error) { })
    };

   

}]);

